<template>
    <div class="fixed z-index-fixed top-0 left-0 w-screen">
        <div class="flex lg:hidden bg-a-egg-f5ebdc shadow-md">
            <div class="flex justify-center w-full p-3 relative">
                <div class="absolute left-3">
                    <img class="py-2" @click="clickBack()" src="@/assets/header/ic-back.svg" />
                </div>
                <div class="flex">
                    <img class="h-8" src="@/assets/header/logo-bk.svg" />
                    <div class="ml-1 my-auto text-a-brown-502314 font-bold">{{headerName}}</div>
                </div>
                <div class="absolute right-3 top-4" v-if="isShowPCI">
                    <img class="h-6" src="@/assets/icon/ic-pci@2x.png" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    name: "TopBar",
    props: {
        headerName: { type: String, default: '' },
        isShowPCI: { type: Boolean, default: false },
    },
    data: function() {
        return {

        };
    },
    methods: {
        clickBack: function() {
            this.$emit("clickBack");
        },
    },
}
</script>
<style lang="scss" scoped>

</style>
